import { render, staticRenderFns } from "./FloatingService.vue?vue&type=template&id=1348c6c7&scoped=true&"
import script from "./FloatingService.vue?vue&type=script&lang=js&"
export * from "./FloatingService.vue?vue&type=script&lang=js&"
import style0 from "./FloatingService.vue?vue&type=style&index=0&id=1348c6c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1348c6c7",
  null
  
)

export default component.exports